import type { PermittedAction } from "../../api/permittedActions";
import { appPaths } from "../../shared/routing/appPaths";

/**
 * Administration's pages (web-app.md WA-8), each with the installation permission its screens
 * ask the server for (accounts.md GS-2): someone holding any of them reaches Administration and
 * sees the pages they may use. The server checks each call again.
 */
export interface AdministrationPage {
  readonly path: string;
  readonly labelKey: string;
  readonly action: PermittedAction;
}

export const ADMINISTRATION_PAGES: readonly AdministrationPage[] = [
  { path: appPaths.administrationAccounts(), labelKey: "administration.pages.accounts", action: "manage_accounts" },
  { path: appPaths.administrationServerKeys(), labelKey: "administration.pages.serverKeys", action: "manage_server_keys" },
  { path: appPaths.administrationInstallation(), labelKey: "administration.pages.installation", action: "manage_installation" },
  { path: appPaths.administrationGroups(), labelKey: "administration.pages.groups", action: "manage_accounts" },
  { path: appPaths.administrationResearchSpace(), labelKey: "administration.pages.researchSpace", action: "manage_installation" },
  { path: appPaths.administrationDeletedProjects(), labelKey: "administration.pages.deletedProjects", action: "manage_deleted_projects" },
];

/** The page an address belongs to, its own screens below it included; `undefined` for none. */
export function administrationPageOf(pathname: string): AdministrationPage | undefined {
  return ADMINISTRATION_PAGES.find((page) => pathname === page.path || pathname.startsWith(`${page.path}/`));
}
